<template>
  <v-container class="wizard" fluid justify-center fill-height>
    <v-icon class="back-button" v-if="step > 0 && step <= steps.length - 2" @click="prev"
      >keyboard_backspace</v-icon
    >
    <transition name="fade" mode="out-in">
      <component
        :is="steps[step]"
        :campaign="campaign"
        onboarding="true"
        v-bind="metrics"
        :showAnimationSettings="false"
        :showPoweredBySettings="false"
        @change='change'
      ></component>
    </transition>
    <div>
      <v-btn
        v-if="step < steps.length - 1"
        color="accent"
        medium
        depressed
        @click="next"
        :loading="saving"
        >{{ $t('next_step') }}</v-btn
      >
    </div>
  </v-container>
</template>

<script>
import BizCategorySelection from '@/components/survey/BizCategorySelection'
import MetricSelection from '@/components/survey/MetricSelection'
import AppearanceWidget from '@/components/survey/AppearanceWidget'
import CopyCode from '@/components/survey/CopyCode'
import constants from '@/constants'
import routes from '@/route_names'

export default {
  name: 'WizardView',
  components: {
    BizCategorySelection,
    MetricSelection,
    AppearanceWidget,
    CopyCode
  },
  data: function() {
    console.log(constants)
    return {
      campaign: {
        brandName: '',
        brandColor: constants.campaign.COLOR,
        language: 'en',
        widgetPosition: 'BOTTOM',
        category: 'SAAS'
      },
      metrics: {
        nps: true,
        csat: true,
        ces: true
      },
      steps: [BizCategorySelection, MetricSelection, AppearanceWidget, CopyCode],
      step: 0,
      saving: false
    }
  },
  methods: {
    next: function() {
      const vm = this
      if (this.step === this.steps.length - 2) {
        this.saving = true
        vm.save().then(function(campaign) {
          vm.$store.dispatch('user/getDetails').then(function(res) {
            if (res.projects.length === 0) {
              console.log('going to wizard')
              vm.$router.push({ name: routes.WIZARD })
            } else {
              console.log('going to SURVEY')
              vm.campaign = res.projects[0].campaigns[0]
              vm.step++
              // vm.$router.push({
              //   name: routes.SURVEY,
              //   params: {
              //     projectId: res.projects[0].id,
              //     campaignId: res.projects[0].campaigns[0].id
              //   }
              // })
            }
          })
        })
      } else {
        if (this.steps.length - 1 > this.step) {
          this.step++
        }
      }
    },
    prev: function() {
      if (this.step > 0) {
        this.step--
      }
    },
    change(data){
      if(this.steps[this.step] === BizCategorySelection){
        this.campaign.category = data.category
      }
      else if(this.steps[this.step] === MetricSelection){
        if(data.metric === 'NPS')
          this.metrics.nps = data.enabled
        else if(data.metric === 'CSAT')
          this.metrics.csat = data.enabled
        else if(data.metric === 'CES')
          this.metrics.ces = data.enabled
      }
    },
    save: function() {
      const vm = this
      return this.$store.dispatch('user/onboardingComplete', {
        data: {
          nps_enabled: vm.metrics.nps,
          csat_enabled: vm.metrics.csat,
          ces_enabled: vm.metrics.ces,
          brand_name: vm.campaign.brandName,
          primary_color: vm.campaign.brandColor,
          primary_lang: vm.campaign.language,
          widget_position: vm.campaign.widgetPosition,
          category:  vm.campaign.category,
        }
      })
    }
  }
}
</script>

<style lang="stylus">
.wizard {
    position relative
    background #fff
    border-radius 10px
    max-width 1300px
    padding 50px
    .back-button {
        position absolute
        top: 25px
        left: 30px
        color: $color-primary-light-5
        cursor pointer
    }
}
</style>
